import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { buttonStyles } from '../../../theme/formStyles';
import TicketCard from '../tickets/TicketCard';

// The client's tickets at this facility with the 4-stage tracker; resolved ones folded away
export default function ClientTicketsPanel({ tickets, onRaise }) {
    const open = tickets.filter(t => t.stage !== 'resolved');
    const resolved = tickets.filter(t => t.stage === 'resolved');
    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.25 }}>
                <Typography sx={{ fontSize: '13px', color: '#6b7785', flex: 1 }}>Problems reported at this site and where each one is.</Typography>
                <Button size="small" variant="outlined" onClick={onRaise} sx={buttonStyles.outlined}>＋ Raise a ticket</Button>
            </Box>
            {!open.length && <Typography sx={{ textAlign: 'center', color: '#6b7785', fontSize: '13px', py: 2 }}>No open tickets.</Typography>}
            {open.map(t => <TicketCard key={t.id} ticket={t} />)}
            {resolved.length > 0 && (
                <Accordion disableGutters sx={{ mt: 1, border: '1px solid #e5e9ee', boxShadow: 'none', borderRadius: '12px !important', '&:before': { display: 'none' } }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}><Typography sx={{ fontSize: '13.5px', fontWeight: 500 }}>Resolved · {resolved.length}</Typography></AccordionSummary>
                    <AccordionDetails>{resolved.map(t => <TicketCard key={t.id} ticket={t} />)}</AccordionDetails>
                </Accordion>
            )}
        </Box>
    );
}
